import { Component, EventEmitter, Input, Output } from '@angular/core';

export interface AlertHistoryRow {
  alertHistoryId: number;
  /** alert/list の patientName（「〇〇さんにアラートが発生しました」の〇〇） */
  patientName: string;
  alertTime: string;
  /** API isRead: 0=未読, 1=既読 */
  isRead: boolean;
}

@Component({
  selector: 'app-alert-history-panel',
  templateUrl: './alert-history-panel.component.html',
  styleUrls: ['./alert-history-panel.component.css'],
})
export class AlertHistoryPanelComponent {
  @Input() open = false;
  @Input() items: AlertHistoryRow[] = [];
  @Output() closed = new EventEmitter<void>();
  /** 未読行クリック時、alertHistoryId を親へ渡す（POST /alert/markAsRead） */
  @Output() markAsRead = new EventEmitter<number>();

  /** 未読のみ */
  unreadOnly = false;

  get displayedRows(): AlertHistoryRow[] {
    if (!this.unreadOnly) {
      return this.items;
    }
    return this.items.filter((r) => !r.isRead);
  }

  close(): void {
    this.closed.emit();
  }

  onOverlayClick(event: MouseEvent): void {
    const t = event.target as HTMLElement;
    if (t.classList.contains('alert-history-overlay')) {
      this.close();
    }
  }

  /** 未読のときだけ markAsRead を emit（既読行では API を呼ばない） */
  onRowClick(row: AlertHistoryRow): void {
    if (row.isRead === true) {
      return;
    }
    this.markAsRead.emit(row.alertHistoryId);
  }
}
